export default __webpack_public_path__ + "static/media/qr-code-2.a59890fa.svg";